/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingInformationRequest {
    getFixupPrototypeFunction() { return BillingInformationRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingInformationRequest>): BillingInformationRequest {
        let obj = Object.assign(new BillingInformationRequest(), model);
        BillingInformationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingInformationRequest>): BillingInformationRequest {
        if (!model) return null;
        return BillingInformationRequest.newInstance(<BillingInformationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingInformationRequest) {
        if (!obj) return;

        models.BillingInformationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingInformationRequest): boolean {
        Object.setPrototypeOf(obj, BillingInformationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * Service Account IDs
     */
    service_account_ids: Array<string>;

    /**
     * start of the spend period
     */
    start_date: Date;

    /**
     * end of the spend period
     */
    end_date: Date;

}
